import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from "@angular/core";
import { MatDialog } from "@angular/material";
import { DatasetActionContainerService } from "app/main/components/dataset/services/dataset-action-container.service";
import { DatasetNavigatorService } from "app/main/components/dataset/services/dataset-navigator.service";
import { DatasetRecordService } from "app/main/components/dataset/services/dataset-record.service";
import { DatasetService } from "app/main/components/dataset/services/dataset.service";
import { DestroyableComponent } from "app/main/destroyable.component";
import { BookingService } from "app/main/pages/edit-booking/booking.service";
import { AppService } from "app/services/app.service";
import { DomainFilterService } from "app/services/domain-filter.service";
import { EMPTY } from "rxjs";
import { TripBookingPackagesStepService } from "../../../trip-booking-packages-step.service";
import { TripBookingPackageService } from "../../trip-booking-package.service";
import { catchError, takeUntil, tap } from "rxjs/operators";
import { ValueTypes, InputTypes } from "app/interfaces";
import { FormDialogComponent } from "app/main/dialogs/form-dialog/dialog.component";
import { ActionDialogComponent } from "app/main/pages/edit-booking/action-dialog/action-dialog.component";
var TripPackageOpenDateBookingBlockComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TripPackageOpenDateBookingBlockComponent, _super);
    function TripPackageOpenDateBookingBlockComponent(appService, datasetRS, datasetACS, datasetNavigatorService, datasetService, matDialog, domainFilterService, tripBookingPackageService, tripBookingPackagesStepService, bookingService, viewContainerRef) {
        var _this = _super.call(this) || this;
        _this.appService = appService;
        _this.datasetRS = datasetRS;
        _this.datasetACS = datasetACS;
        _this.datasetNavigatorService = datasetNavigatorService;
        _this.datasetService = datasetService;
        _this.matDialog = matDialog;
        _this.domainFilterService = domainFilterService;
        _this.tripBookingPackageService = tripBookingPackageService;
        _this.tripBookingPackagesStepService = tripBookingPackagesStepService;
        _this.bookingService = bookingService;
        _this.viewContainerRef = viewContainerRef;
        _this.canResendEmail = false;
        _this.canConfirmDate = false;
        _this.tripBookingPackage = null;
        _this.statusMessage = null;
        return _this;
    }
    TripPackageOpenDateBookingBlockComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.datasetRS.record
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (record) {
            _this.tripBookingPackage = record;
            _this.canResendEmail = _this.tripBookingPackage.booking_status == 'optional' && ['require_customer_confirm', 'require_customer_payment'].includes(_this.tripBookingPackage.booking_sub_status);
            _this.canConfirmDate = _this.tripBookingPackage.booking_status == 'optional' && _this.tripBookingPackage.booking_sub_status == 'require_admin_confirm';
            _this.statusMessage = _this.makeStatusMessage();
        });
    };
    TripPackageOpenDateBookingBlockComponent.prototype.makeStatusMessage = function () {
        if (this.tripBookingPackage.booking_status != 'optional')
            return null;
        if (this.tripBookingPackage.booking_sub_status == 'require_customer_confirm')
            return 'In attesa di conferma dal cliente.';
        if (this.tripBookingPackage.booking_sub_status == 'require_customer_payment')
            return 'In attesa di pagamento dal cliente.';
        if (this.tripBookingPackage.booking_sub_status == 'require_admin_confirm')
            return 'Conferma la data proposta dal cliente.';
        return null;
    };
    TripPackageOpenDateBookingBlockComponent.prototype.execCommand = function (commandCode, data) {
        var _this = this;
        this.tripBookingPackagesStepService.loading = true;
        var dialogRef = this.matDialog.open(ActionDialogComponent, {
            width: '550px',
            data: {
                title: 'Azione in corso'
            }
        });
        return this.datasetService.post('/dataset/trip_booking_packages/command/' + commandCode, data)
            .pipe(takeUntil(this._unsubscribeAll), tap(function (response) {
            _this.tripBookingPackagesStepService.loading = false;
            _this.onActionResponse(response, dialogRef);
        }), catchError(function (errorResponse) {
            _this.tripBookingPackagesStepService.loading = false;
            _this.onErrorActionResponse(errorResponse, dialogRef);
            return EMPTY;
        }));
    };
    TripPackageOpenDateBookingBlockComponent.prototype.resendEmailToCustomer = function () {
        var _this = this;
        this.execCommand('send_open_date_email_to_customer', {
            trip_booking_package_id: this.tripBookingPackage.id,
        })
            .subscribe({
            next: function (response) {
                _this.datasetRS.reload();
            }
        });
    };
    TripPackageOpenDateBookingBlockComponent.prototype.confirmDate = function () {
        var _this = this;
        this.execCommand('confirm_open_date', {
            trip_booking_package_id: this.tripBookingPackage.id,
        })
            .subscribe({
            next: function (response) {
                _this.datasetRS.reload();
            }
        });
    };
    TripPackageOpenDateBookingBlockComponent.prototype.changeDate = function () {
        var _this = this;
        var formFields = [
            {
                key: 'start_day',
                name: 'Giorno',
                valueType: ValueTypes.STRING,
                inputConfig: {
                    type: InputTypes.DATE
                }
            },
            {
                key: 'start_time',
                name: 'Orario',
                valueType: ValueTypes.STRING,
                inputConfig: {
                    type: InputTypes.TIME
                }
            }
        ];
        if (this.tripBookingPackage.booking_status == 'optional') {
            formFields.push({
                key: 'send_email',
                name: 'Invia email',
                valueType: ValueTypes.NUMBER,
                inputConfig: {
                    type: InputTypes.CHECKBOX
                },
                titleIcon: 'info',
                titleTooltip: 'Verra inviata l\'email con il link per confermare e completare il pagamento.'
            });
        }
        this.matDialog.open(FormDialogComponent, {
            data: {
                title: 'Cambia data',
                formData: {
                    start_day: this.tripBookingPackage.actual_trip.start_day,
                    start_time: this.tripBookingPackage.actual_trip.start_time,
                    send_email: 1
                },
                formConfig: {
                    fields: formFields
                }
            }
        }).afterClosed()
            .subscribe(function (formResult) {
            if (!formResult)
                return;
            _this.execCommand('change_open_date', {
                trip_booking_package_id: _this.tripBookingPackage.id,
                start_day: formResult.start_day,
                start_time: formResult.start_time,
                send_email: formResult.send_email
            })
                .subscribe({
                next: function (response) {
                    _this.datasetRS.reload();
                }
            });
        });
    };
    TripPackageOpenDateBookingBlockComponent.prototype.onActionResponse = function (response, dialogRef) {
        if (!dialogRef || !dialogRef.componentInstance) {
            dialogRef = this.matDialog.open(ActionDialogComponent, {
                width: '550px',
                data: {}
            });
        }
        dialogRef.componentInstance.loading = false;
        if (response.success) {
            dialogRef.componentInstance.resultStatus = 'success';
            dialogRef.componentInstance.setTitle('Completato');
        }
        else {
            dialogRef.componentInstance.resultStatus = 'error';
            dialogRef.componentInstance.setTitle('Errore');
        }
        if (response.message) {
            dialogRef.componentInstance.setMessage(response.message);
        }
    };
    TripPackageOpenDateBookingBlockComponent.prototype.onErrorActionResponse = function (response, dialogRef) {
        if (!dialogRef || !dialogRef.componentInstance) {
            dialogRef = this.matDialog.open(ActionDialogComponent, {
                width: '550px',
                data: {
                    title: 'Azione in corso'
                }
            });
        }
        dialogRef.componentInstance.loading = false;
        dialogRef.componentInstance.resultStatus = 'error';
        dialogRef.componentInstance.setTitle('Errore');
        if (response.error && response.error.message) {
            dialogRef.componentInstance.setMessage(response.error.message);
        }
        else {
            if (response.error)
                dialogRef.componentInstance.setMessage(response.error);
            else
                dialogRef.componentInstance.setMessage('Si è verificato un errore.');
        }
    };
    return TripPackageOpenDateBookingBlockComponent;
}(DestroyableComponent));
export { TripPackageOpenDateBookingBlockComponent };
